import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./CaseStudies.css"
import "bootstrap/dist/css/bootstrap.min.css";
import "./CaseStudies.css";
import {
  CustomerStories,
  solutionBriefs,
} from "../../StaticData/caseStudiesData";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const CaseStudies = () => {
  return (
    <div className="CaseStudies-page">
      <Helmet>
        <title>Case Studies | Idexcel</title>
        <meta
          content="cloud migration case studies, devops case studies, devops implementation case studies, aws well-architected, machine learning"
          name="keywords"
        />
        <meta
          content="Read our latest case studies to learn how Idexcel helped clients transform their businesses and stay at the top of our ever-changing industry."
          name="description"
        />
      </Helmet>
      {/* //banner section  */}
      <motion.div
        className="Productright"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
      <Container fluid className="casestudy-banner-container p-0">
        <section className="casestudy-banner-section"></section>
      </Container>
      </motion.div>

      {/* section 2 */}
      <Container className="mt-5">
        <h2 className="text-center mb-4 section-title">
          Our <span className="textgrad">Case Studies</span>{" "}
        </h2>
        <Row>
          {CustomerStories.map((study) => (
            <Col key={study.id} xs={12} md={6} xl={4} className="mb-5 px-4">
              <div className="case-study-wrapper">
                <Card
                  style={{ minHeight: "450px" }}
                  className=" case-study-box"
                >
                  <a
                    href={study.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Img
                      variant="top"
                      src={study.image}
                      alt={study.title}
                    />
                  </a>
                  <Card.Body className="case-study-body border-bottom position-relative">
                    <a
                      href={study.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="case-study-title"
                    >
                      <Card.Title>{study.title}</Card.Title>
                    </a>
                    <Card.Text style={{lineHeight:"22px"}}>{study.description}</Card.Text>

                    <a
                      className="case-study-read position-absolute mb-2"
                      variant="primary"
                      href={study.link}
                      target="_blank"
                    >
                      Read More
                      <i
                        className="bi bi-arrow-up-right"
                        style={{ fontSize: "12px", marginLeft:"5px" }}
                      ></i>
                    </a>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* section 3 */}
      <Container className="mb-5">
        <h2 className="text-center mb-4 section-title">
          <span className="textgrad"> Solution</span> Briefs
        </h2>
        <Row className="d-flex justify-content-center">
          {solutionBriefs.map((brief) => (
            <Col key={brief.id} xs={12} md={4} className="mb-4">
              <div className="case-study-wrapper">
                <Card className="case-study-box" style={{ minHeight: "450px" }}>
                  <a
                    href={brief.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Img
                      variant="top"
                      src={brief.image}
                      alt={brief.title}
                    />
                  </a>
                  <Card.Body className="case-study-body border-bottom position-relative">
                    <a
                      href={brief.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="case-study-title"
                    >
                      <Card.Title>{brief.title}</Card.Title>
                    </a>
                    <Card.Text>{brief.description}</Card.Text>

                    <a
                      className="case-study-read  position-absolute mb-2"
                      variant="primary"
                      href={brief.link}
                      target="_blank"
                    >
                      Read More
                      <i
                        className="bi bi-arrow-up-right"
                        style={{ fontSize: "12px", marginLeft:"5px" }}
                      ></i>
                    </a>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CaseStudies;
